// extracted by mini-css-extract-plugin
export var breadcrumb = "{mdx-slug}-module--breadcrumb--NsvVL";
export var container = "{mdx-slug}-module--container--1GXpQ";
export var containerSm = "{mdx-slug}-module--container-sm--Yc2N3";
export var article = "{mdx-slug}-module--article--38hlT";
export var closeWrapper = "{mdx-slug}-module--close-wrapper--WSATG";
export var close = "{mdx-slug}-module--close--b8a+w";
export var focusVisible = "{mdx-slug}-module--focus-visible--0dPow";
export var modal = "{mdx-slug}-module--modal--qIQOl";